import { PhysicianActions } from 'src/redux/actions/constant';

const {
  REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
} = PhysicianActions;

const intialFacilityState: any = {
  areGetDocuments: false,
  response: null,
  loading: false,
  totalDocument: [],
  currentPage: -1,
  pageNumber: 0,
};
export const completedPhysicianDocumentReducer = (state = intialFacilityState, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          areGetDocuments: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalDocument: [...state.totalDocument, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          areGetDocuments: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalDocument: action.payload?.data?.content || [],
        };
      }
    }

    case FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS:
      return {
        ...state,
        areGetDocuments: false,
        response: action.payload,
      };

    case LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS:
      return {
        ...state,
        loading: true,
      };

    case RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS:
      return intialFacilityState;

    default:
      return state;
  }
};
